import { action } from 'mobx';
import parseDate from '../shared/parseDate';
import ModelBase from './ModelBase';

export default class History extends ModelBase {
  static className = 'History';

  @action
  static fromJSON(id, json) {
    json.hstAhInvDate = parseDate(json.hstAhInvDate);
    
    const result = super.fromJSON(id, json);

    return result;
  }
}



// WEBPACK FOOTER //
// ./src/store/History.js